<template>
  <v-dialog width="800" v-model="showAcceptRemarksDialog">
    <v-card>
      <v-card-title class="green darken-2 white--text">
        <span> Confirmed Company || {{ companyRequestNo }} </span>

        <v-spacer></v-spacer>

        <v-btn icon @click="resetForm(), (showAcceptRemarksDialog = false)">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-form
          ref="remarksForm"
          v-if="showAcceptRemarksDialog"
          v-model="isValid"
        >
          <v-row class="my-0">
            <v-col cols="12" class="Form-Columns">
              <InputField
                label="Sap Company Code *"
                required
                :rules="[(val) => !!val || 'Sap Company Code is Required!']"
                hide-details="auto"
                :clearable="true"
                v-model="remarksDetails.sap_code"
                :error-messages="formErrors.sap_code"
                @input="delete formErrors.sap_code"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          depressed
          :disabled="!isValid"
          @click="acceptCompanyRequests"
        >
          Submit
        </v-btn>

        <v-btn class="ml-3" color="secondary" depressed @click="resetForm">
          Reset
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";

export default {
  components: {
    InputField,
    MultiSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },

    companyRequestID: {
      type: [Number, null],
      default: null,
    },
    companyRequestNo: {
      type: [String, null],
      default: null,
    },
  },
  watch: {
    value(val) {
      if (val) {
      } else {
        this.resetForm();
      }
    },
  },
  computed: {
    showAcceptRemarksDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      isValid: true,
      isTextInput: false,
      formErrors: {},
      remarksDetails: {},
    };
  },
  methods: {
    acceptCompanyRequests() {
      let payload = {
        id: this.companyRequestID,
        sap_code: this.remarksDetails.sap_code,
      };
      this.$api.user
        .acceptCompanyRequest(payload)
        .then((res) => {
          this.$emit("refreshList");
          this.showAcceptRemarksDialog = false;
        })
        .catch((err) => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Couldn't Update status!",
            color: "error",
          });
        });
    },

    resetForm() {
      if (this.$refs.remarksForm) {
        this.$refs.remarksForm.reset();
      }
      this.remarksDetails = {};
    },
  },
};
</script>
